import { createSlice } from '@reduxjs/toolkit';

export const analyticsInitialState = {
  mentor: null,
};

export const analyticsSlice = createSlice({
  name: 'analytics',
  initialState: analyticsInitialState,
  reducers: {
    mentorUpdated: (state, action) => {
      state.mentor = action.payload;
    },
  },
});

export const analyticsActions = analyticsSlice.actions;
export default analyticsSlice.reducer;
